import { Box, Typography } from "@mui/material";

const BoxPrint = () => {
  return (
    <>
      <Box
        sx={{
          width: "800px",
          margin: "0 auto",
          padding: 3,
          background: "#fff",
          color: "#000",
          fontSize: "14px",
        }}
      >
        {/* Title */}
        <Typography variant="h6" fontWeight="bold" mb={2}>
          Representation of Materials to be Delivered
        </Typography>

        {/* Customer Info */}
        <Box mb={2}>
          <Typography>
            <b>Customer:</b> Fred Blogges
          </Typography>
          <Typography>
            <b>Address:</b> 142 The Brent, Dartford DA2 6DE
          </Typography>
          <Typography>
            <b>Mobile:</b> 07929543166
          </Typography>
          <Typography>
            <b>Email:</b> fred@live.com
          </Typography>
          <Typography>
            <b>Delivery Date & Time:</b> 12/12/2025 10:00
          </Typography>
        </Box>

        {/* Table Header */}
        <Box
          sx={{
            background: "#4a7bd1",
            color: "#fff",
            padding: "8px",
            fontWeight: "bold",
          }}
        >
          Materials to be Delivered
        </Box>

        {/* Table */}
        <Box>
          {[
            ["Fragile Boxes (Med. box, trunk info only)", 7],
            ["Medium Boxes 457x305x305", 24],
            ["Large Boxes 457x457x457", 37],
            ["Bubble Wrap 300x75m roll", 1],
            ["Packing Tape", 4],
            ["Tissue Paper (5 Kilo Packets)", 1],
            ["Wardrobe Cartons", 0],
            ["Picture Sleeve", 0],
            ["Delivery Charge", 1],
            ["Carpet Protector", 0],
            ["Lay-Flat Clothes Box", 0],
            ["Export Wrap 100m", 0],
          ].map((item, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                borderBottom: "1px solid #ccc",
                padding: "6px 4px",
              }}
            >
              <Typography>{item[0]}</Typography>
              <Typography>{item[1]}</Typography>
            </Box>
          ))}
        </Box>

        {/* Signature Section (Bottom) */}
        <Box mt={6}>
          {["Customer Signature", "Print", "Date"].map((label, i) => (
            <Box
              key={i}
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 2,
              }}
            >
              <Typography sx={{ width: 180 }}>{label}</Typography>
              <Box sx={{ flex: 1, borderBottom: "1px solid black" }} />
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
};

export default BoxPrint;
